/**
 * Le canal par lequel le réparateur a amené le client sur sa fiche
 * (FIXERLIGHT-062, contrat api `docs/specs/fixerlight-062-origine-des-affaires.md`).
 *
 * Le lien et le QR code de sa page de réservation (rj-atelier) ouvrent la fiche
 * avec `?via=lien` ou `?via=qr`. La demande peut partir bien plus tard : après
 * les étapes du tunnel, ou après un aller-retour de connexion qui revient sur
 * la fiche sans le paramètre. On retient donc le marqueur à l'arrivée, dans
 * `sessionStorage` et par fiche, plutôt que de relire l'adresse à l'envoi.
 *
 * Seules `lien` et `qr` passent, à l'écriture comme à la lecture : l'api
 * refuse toute autre valeur en 422, et une adresse retouchée à la main ne doit
 * jamais faire échouer une réservation. Rien de tout cela ne s'affiche.
 */
const VALEURS = ['lien', 'qr'];
const cle = (shopId) => `rj-annuaire-via-${shopId}`;

/** À l'arrivée sur la fiche : retient `?via=` s'il vaut `lien` ou `qr`. */
export function retenirVia(shopId, search) {
  if (typeof window === 'undefined') return;
  try {
    const via = new URLSearchParams(search).get('via');
    if (VALEURS.includes(via)) window.sessionStorage.setItem(cle(shopId), via);
  } catch (e) {
    // Stockage refusé : la demande comptera en plateforme RJ, rien de plus.
  }
}

/** À l'envoi : `{ via }` à joindre à la demande, ou un objet vide. */
export function viaRetenu(shopId) {
  if (typeof window === 'undefined') return {};
  try {
    const via = window.sessionStorage.getItem(cle(shopId));
    return VALEURS.includes(via) ? { via } : {};
  } catch (e) {
    return {};
  }
}
